import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import { initialTimeOffColumns } from 'views/pages/TimeOff/hooks/useTimeOffTable';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

type TimeOffColumnKey =
  'user' | 'role' | 'start_date' | 'end_date' | 'duration' | 'type' | 'status';

const TIME_OFF_TABLE_COLUMN_LABELS: Record<TimeOffColumnKey, string> = {
  user: 'User',
  role: 'Role',
  start_date: 'Start date',
  end_date: 'End date',
  duration: 'Duration',
  type: 'Type',
  status: 'Status',
};

const ALL_FIELDS = initialTimeOffColumns
  .map(c => c.field)
  .filter(f => f !== 'actions') as TimeOffColumnKey[];

interface ITimeOffTableColumnSelectionFilterProps {
  hiddenColumns: string[];
  setHiddenColumns: (hiddenColumns: string[]) => void;
  hideText?: boolean;
}

export const TimeOffTableColumnSelectionFilter = ({
  hiddenColumns,
  setHiddenColumns,
  hideText,
}: ITimeOffTableColumnSelectionFilterProps) => {
  const columns: Partial<Record<TimeOffColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<TimeOffColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  return (
    <ColumnSelectionFilter
      name='time_off_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={TIME_OFF_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
